import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertTradingData } from "../thunks/upsertTradingData";
import { setFetchState } from "../tradingDataSlice";
import { TradingData } from "../types";

export const useTradingDataUpsert = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.clearing.tradingData.fetchState
  );

  const dispatch = useDispatch();
  const dispatchUpsertTradingData = React.useCallback(
    (tradingData: TradingData) => dispatch(upsertTradingData(tradingData)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchUpsertTradingData] as [
    typeof fetchState,
    typeof dispatchUpsertTradingData
  ];
};
